import type { StepIndicatorStep } from '~/components/StepIndicator.vue';

export const CHECKOUT_STEP_1_NAME = 'Komplettera';
export const CHECKOUT_STEP_2_NAME = 'Nummer';
export const CHECKOUT_STEP_3_NAME = 'Dina uppgifter';
export const CHECKOUT_STEP_4_NAME = 'Betalning';

export const defaultCheckoutIndicatorSteps: StepIndicatorStep[] = [
  {
    name: CHECKOUT_STEP_1_NAME,
  },
  {
    name: CHECKOUT_STEP_2_NAME,
  },
  {
    name: CHECKOUT_STEP_3_NAME,
  },
  {
    name: CHECKOUT_STEP_4_NAME,
  },
];

export const checkoutIndicatorStepsNoNumber: StepIndicatorStep[] = [
  {
    name: CHECKOUT_STEP_1_NAME,
  },
  {
    name: CHECKOUT_STEP_3_NAME,
  },
  {
    name: CHECKOUT_STEP_4_NAME,
  },
];
